import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import useTheme from "hooks/useTheme";

import { logoutUser } from "actions/auth";

import ContactsListIcon from "theme/icons/ContactsList";
import TAccountsIcon from "theme/icons/TAccounts";
import SearchIcon from "theme/icons/Search";
import ReportsIcon from "theme/icons/Reports";
import LogoutIcon from "theme/icons/Logout";
import AddIcon from "theme/icons/Add";
import ImportIcon from "theme/icons/Import";
import SelectedDotIcon from "theme/icons/SelectedDot";
import ConnectIcon from "theme/icons/Connect";
import useNotification from "hooks/useNotification";
import AccountsIcon from "theme/icons/Accounts";
import SettingsIcon from "theme/icons/Settings";

const Sidebar = ({ navigatePage }) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const { notify } = useNotification();

	const { themeColor, appLanguage } = useTheme();

	return (
		<aside className="w-fit overflow-y-auto items-center justify-start space-y-6 px-3">
			<div className="w-full flex flex-col space-y-2">
				<Link to="/CreateTAccount">
					<div
						className={`w-full flex items-center justify-center py-5 px-3 rounded-md ${themeColor?.border} ${
							location.pathname === "/CreateTAccount" && "border"
						} ${themeColor?.bg} bg-opacity-10 cursor-pointer smooth hover:shadow-lg`}
					>
						<div className="flex space-x-4">
							<AddIcon className={`w-5`} fill={themeColor?.hex} />

							<h1 className={`text-center font-medium ${themeColor?.text} text-sm`}>
								{/* {appLanguage?.newAccount}
								<br /> */}
								{appLanguage?.newAccount}
							</h1>
						</div>
					</div>
				</Link>

				<Link to="/ImportTAccount">
					<div
						className={`w-full flex items-center justify-center py-5 px-3 rounded-md ${themeColor?.border} ${
							location.pathname === "/ImportTAccount" && "border"
						} ${themeColor?.bg} bg-opacity-10 cursor-pointer smooth hover:shadow-lg`}
					>
						<div className="flex space-x-4">
							<ImportIcon className={`w-5`} fill={themeColor?.hex} />

							<h1 className={`text-center font-medium ${themeColor?.text} text-sm`}>
								{appLanguage?.importAccount}
								<br />
								{/* {appLanguage?.importAccount} */}
							</h1>
						</div>
					</div>
				</Link>
			</div>

			<div className={`w-full flex flex-col`}>
				<Link to="/" className={`w-full flex items-center justify-between py-2 px-1 space-x-3`}>
					{location.pathname === "/" ? (
						<SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />
					) : (
						<div className="w-4"></div>
					)}

					<div className="flex w-full items-center space-x-3">
						<AccountsIcon className={`w-5`} fill={themeColor?.hex} />

						<h1 className={`font-medium ${themeColor?.text} text-sm`}>{appLanguage?.home}</h1>
					</div>
				</Link>
			</div>

			<div className="w-full flex flex-col">
				<Link to="/Connect" className={`w-full flex items-center justify-between py-2 px-1 space-x-3`}>
					{location.pathname === "/Connect" ? (
						<SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />
					) : (
						<div className="w-4"></div>
					)}

					<div className="flex w-full items-center space-x-3">
						<ConnectIcon className={`w-5`} fill={themeColor?.hex} />

						<h1 className={`font-medium ${themeColor?.text} text-sm`}>{appLanguage?.connect}</h1>
					</div>
				</Link>

				<Link to="/Accounts" className={`w-full flex items-center justify-between py-2 px-1 space-x-3`}>
					{location.pathname === "/Accounts" ? (
						<SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />
					) : (
						<div className="w-4"></div>
					)}

					<div className="flex w-full items-center space-x-3">
						<TAccountsIcon className={`w-5`} fill={themeColor?.hex} />

						<h1 className={`font-medium ${themeColor?.text} text-sm`}>{appLanguage?.myAccounts}</h1>
					</div>
				</Link>

				<Link to="/Contacts" className={`w-full flex items-center justify-between py-2 px-1 space-x-3`}>
					{location.pathname === "/Contacts" ? (
						<SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />
					) : (
						<div className="w-4"></div>
					)}

					<div className="flex w-full items-center space-x-3">
						<ContactsListIcon className={`w-5`} fill={themeColor?.hex} />

						<h1 className={`font-medium ${themeColor?.text} text-sm`}>{appLanguage?.myContacts}</h1>
					</div>
				</Link>
			</div>

			<div className="w-full flex flex-col">
				<Link to="/Search" className={`w-full flex items-center justify-between py-2 px-1 space-x-3`}>
					{location.pathname === "/Search" ? (
						<SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />
					) : (
						<div className="w-4"></div>
					)}

					<div className="flex w-full items-center space-x-3">
						<SearchIcon className={`w-5`} fill={themeColor?.hex} />

						<h1 className={`font-medium ${themeColor?.text} text-sm`}>{appLanguage?.advancedSearch}</h1>
					</div>
				</Link>

				<Link to="/Reports" className={`w-full flex items-center justify-between py-2 px-1 space-x-3`}>
					{location.pathname === "/Reports" ? (
						<SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />
					) : (
						<div className="w-4"></div>
					)}

					<div className="flex w-full items-center space-x-3">
						<ReportsIcon className={`w-5`} fill={themeColor?.hex} />

						<h1 className={`font-medium ${themeColor?.text} text-sm`}>{appLanguage?.reports}</h1>
					</div>
				</Link>

				<Link to="/Settings" className={`w-full flex items-center justify-between py-2 px-1 space-x-3`}>
					{location.pathname === "/Settings" ? (
						<SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />
					) : (
						<div className="w-4"></div>
					)}

					<div className="flex w-full items-center space-x-3">
						<SettingsIcon className={`w-5`} fill={themeColor?.hex} />

						<h1 className={`font-medium ${themeColor?.text} text-sm`}>{appLanguage?.settings}</h1>
					</div>
				</Link>
			</div>

			<div className="w-full flex flex-col">
				<button
					className={`w-full flex items-center justify-between py-2 px-1 space-x-3`}
					onClick={() => dispatch(logoutUser(navigatePage, notify))}
				>
					<div className="w-4"></div>
					<div className="flex w-full items-center space-x-3">
						<LogoutIcon className={`w-5`} fill={themeColor?.hex} />

						<h1 className={`font-medium ${themeColor?.text} text-sm`}>{appLanguage?.logout}</h1>
					</div>
				</button>
			</div>
		</aside>
	);
};

export default Sidebar;
